import type { State } from '../api/types';
import { stateName } from '../lib/status';
import { LegacyStatusIcon, type LegacyStatusName } from './LegacyIcon';

const STATUS_NAMES = new Set<LegacyStatusName>(['todo', 'process', 'done', 'accept', 'fix', 'pause', 'delete', 'notrequired', 'empty']);

export function StatusBadge({ state, compact = false }: { state: Pick<State, 'type'>; compact?: boolean }) {
  const rawName = state.type?.name;
  const identifier = rawName || state.type?.id || '';
  const name = STATUS_NAMES.has(identifier as LegacyStatusName)
    ? identifier as LegacyStatusName
    : stateName(identifier);
  return (
    <span className={`status status--${name}${compact ? ' status--compact' : ''}`}>
      <LegacyStatusIcon name={name} />
      <span>{state.type?.text ?? 'пусто'}</span>
    </span>
  );
}
